import clsx from 'clsx';
import React from 'react';
import { useCarousel } from './CarouselContext';

type CarouselIndicatorsElement = React.ElementRef<'div'>;
type CarouselIndicatorsProps = React.ComponentPropsWithoutRef<'div'>;

// eslint-disable-next-line react-x/no-forward-ref -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
export const CarouselIndicators = React.forwardRef<
  CarouselIndicatorsElement,
  CarouselIndicatorsProps
>((props, forwardedRef) => {
  const { index, internal_itemsCount, setIndex } = useCarousel();

  return (
    <div {...props} className="text-grey-400 flex gap-1" ref={forwardedRef}>
      {Array.from({ length: internal_itemsCount }).map((_, i) => {
        const isCurrent = i === index;
        return (
          <button
            className={clsx('transition-colors', {
              'text-brand-primary-500': isCurrent,
            })}
            onClick={() => setIndex(i)}
            type="button"
            // eslint-disable-next-line react-x/no-array-index-key -- TODO: Wait! Don't change this file without seeing if you can remove this disable. It was added during a bulk version update, but fixing it would leave the park nicer than you found it.
            key={i}
            aria-label={isCurrent ? 'Current' : `Go to ${i + 1}`}
          >
            {isCurrent ? '●' : '○'}
          </button>
        );
      })}
    </div>
  );
});

CarouselIndicators.displayName = 'CarouselIndicators';
